/* HVMAN — carrito lateral.
   Se abre al agregar un producto (llamado desde global.js) y al tocar el ícono del carrito.
   Lee el carrito desde /cart.js y lo dibuja; permite cambiar cantidades, eliminar
   y agregar productos recomendados.
   Recomendados: se toman de la colección Hombre o Mujer según por dónde navegó el cliente
   (o si tiene calzas en el carrito). En Mujer se ofrecen primero la calza corta y la larga.
   "Elegir talla" abre las tallas dentro de la tarjeta para agregar sin salir del carrito. */
(function () {
  'use strict';

  var cfg = window.HVMAN_CART_DRAWER || { freeShippingCents: 3500000 };
  var drawer, overlay, body, ship, subtotalEl, countEl, addedEl, foot;
  var origFetch = window.fetch.bind(window);
  var jsonCache = {};

  // Cuando el tema agrega un producto (/cart/add), abrimos el carrito lateral.
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch(input, init);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
      p.then(function (res) {
        if (res.ok && window.HVMANCartDrawer) setTimeout(function () { window.HVMANCartDrawer.open({ added: true }); }, 60);
      }).catch(function () {});
    }
    return p;
  };

  function money(cents) {
    return new Intl.NumberFormat('es-CL', {
      style: 'currency', currency: 'CLP', minimumFractionDigits: 0, maximumFractionDigits: 0
    }).format(Math.round(cents / 100));
  }

  function cleanTitle(t) {
    return String(t || '').replace(/\s*-?\s*(Hombre|Mujer|HOMBRE|MUJER)\s*$/, '');
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function img(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function getJSON(url) {
    if (!jsonCache[url]) {
      jsonCache[url] = origFetch(url, { headers: { Accept: 'application/json' } }).then(function (r) {
        if (!r.ok) throw new Error('fetch ' + url);
        return r.json();
      });
      jsonCache[url].catch(function () { delete jsonCache[url]; });
    }
    return jsonCache[url];
  }

  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
    });
    if (countEl) countEl.textContent = n > 0 ? '(' + n + ')' : '';
  }

  var TRUCK = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="1" y="4" width="14" height="12" rx="1"/><path d="M15 8h4l3 4v4h-7z"/><circle cx="5.5" cy="18" r="2"/><circle cx="18.5" cy="18" r="2"/></svg>';

  function bar(pct) {
    return '<div class="cd__bar"><span style="width:' + pct + '%"></span>' +
      '<i class="cd__truck' + (pct >= 100 ? ' is-done' : '') + '" style="left:' + pct + '%">' + TRUCK + '</i></div>';
  }

  function renderShip(total) {
    var goal = cfg.freeShippingCents;
    var pct = Math.min(100, Math.round((total / goal) * 100));
    if (total >= goal) {
      ship.innerHTML = '<strong>¡Tienes ENVÍO GRATIS!</strong>' + bar(100);
    } else {
      ship.innerHTML = 'Te faltan <strong>' + money(goal - total) + '</strong> para el <strong>ENVÍO GRATIS</strong>' + bar(pct);
    }
  }

  /* ---------- Hombre / Mujer ---------- */
  function rememberGender() {
    var m = location.pathname.match(/\/collections\/(hombre|mujer)/);
    if (!m) {
      var crumb = document.querySelector('.breadcrumb a[href="/collections/mujer"], .breadcrumb a[href="/collections/hombre"]');
      if (crumb && document.body.classList.contains('template-product')) m = [null, crumb.getAttribute('href').split('/').pop()];
    }
    if (m) { try { sessionStorage.setItem('hv_gender', m[1]); } catch (e) {} }
  }

  function getGender(cart) {
    var isMujer = cart.items.some(function (i) {
      return /mujer|calza/i.test((i.product_title || '') + ' ' + (i.handle || ''));
    });
    if (isMujer) return 'mujer';
    var g = null;
    try { g = sessionStorage.getItem('hv_gender'); } catch (e) {}
    return g === 'mujer' ? 'mujer' : 'hombre';
  }

  function render(cart) {
    setCount(cart.item_count);
    renderShip(cart.total_price);
    subtotalEl.textContent = money(cart.total_price);

    if (!cart.items.length) {
      body.innerHTML = '<p class="cd__empty">Tu carrito está vacío.</p>';
      foot.style.display = 'none';
      return;
    }
    foot.style.display = '';

    var html = cart.items.map(function (item, i) {
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="cd__variant">Talla: ' + esc(item.variant_title) + '</p>' : '';
      return '<div class="cd__item">' +
        '<a href="' + esc(item.url) + '"><img src="' + esc(img(item.image, 160)) + '" alt="" loading="lazy"></a>' +
        '<div>' +
          '<p class="cd__name">' + esc(cleanTitle(item.product_title)) + '</p>' + variant +
          '<div class="cd__row">' +
            '<div class="cd__qty">' +
              '<button type="button" data-cd-qty="' + (i + 1) + '" data-q="' + (item.quantity - 1) + '" aria-label="Quitar uno">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-cd-qty="' + (i + 1) + '" data-q="' + (item.quantity + 1) + '" aria-label="Agregar uno">+</button>' +
            '</div>' +
            '<span class="cd__price">' + money(item.final_line_price) + '</span>' +
          '</div>' +
          '<button type="button" class="cd__remove" data-cd-qty="' + (i + 1) + '" data-q="0">Eliminar</button>' +
        '</div>' +
      '</div>';
    }).join('');

    body.innerHTML = html + '<div class="cd__recs" data-cd-recs></div>';
    loadRecs(cart);
  }

  /* ---------- Recomendados ---------- */
  function pickImage(prod, gender) {
    var media = (prod.media || []).filter(function (m) { return m.alt === gender; })[0];
    if (media) return (media.preview_image && media.preview_image.src) || media.src;
    return prod.featured_image || '';
  }

  function recCard(prod, gender) {
    var url = '/collections/' + gender + '/products/' + prod.handle;
    var variants = prod.variants || [];
    var multi = variants.length > 1;
    var firstAvail = variants.filter(function (v) { return v.available; })[0];
    if (!firstAvail) return '';
    var action;
    if (multi) {
      action = '<button type="button" class="cd__rec-btn" data-cd-sizes>Elegir talla</button>' +
        '<div class="cd__sizes" hidden>' +
          variants.map(function (v) {
            return '<button type="button" class="cd__size" data-cd-add="' + v.id + '"' +
              (v.available ? '' : ' disabled aria-label="' + esc(v.title) + ' agotada"') + '>' + esc(v.title) + '</button>';
          }).join('') +
        '</div>';
    } else {
      action = '<button type="button" class="cd__rec-btn" data-cd-add="' + firstAvail.id + '">+ Agregar</button>';
    }
    return '<div class="cd__rec">' +
      '<a href="' + esc(url) + '"><img src="' + esc(img(pickImage(prod, gender), 300)) + '" alt="" loading="lazy"></a>' +
      '<p>' + esc(cleanTitle(prod.title)) + '<br><strong>' + money(prod.price) + '</strong></p>' +
      action +
      '<a class="cd__rec-link" href="' + esc(url) + '">Ver producto</a>' +
    '</div>';
  }

  function loadRecs(cart) {
    var box = body.querySelector('[data-cd-recs]');
    if (!box || !cart.items.length) return;
    var gender = getGender(cart);
    var inCart = cart.items.map(function (i) { return i.handle; });
    var titlesInCart = cart.items.map(function (i) { return (i.product_title || '').toLowerCase(); }).join(' | ');

    getJSON('/collections/' + gender + '/products.json?limit=50')
      .then(function (data) {
        var list = (data.products || []).filter(function (p) {
          return inCart.indexOf(p.handle) === -1 &&
            (p.variants || []).some(function (v) { return v.available; });
        });
        var picks = [];
        if (gender === 'mujer') {
          ['calza corta', 'calza larga'].forEach(function (k) {
            if (titlesInCart.indexOf(k) > -1) return;
            var c = list.filter(function (p) { return p.title.toLowerCase().indexOf(k) > -1 && picks.indexOf(p) === -1; })[0];
            if (c) picks.push(c);
          });
        }
        list.forEach(function (p) { if (picks.length < 4 && picks.indexOf(p) === -1) picks.push(p); });
        if (!picks.length) throw new Error('no recs');
        return Promise.all(picks.map(function (p) {
          return getJSON('/products/' + p.handle + '.js').catch(function () { return null; });
        }));
      })
      .then(function (prods) {
        if (!box.isConnected) return;
        var cards = prods.filter(Boolean).map(function (p) { return recCard(p, gender); }).join('');
        if (!cards) { box.remove(); return; }
        box.innerHTML = '<p class="cd__recs-title">Completa tu compra</p><div class="cd__recs-list">' + cards + '</div>';
      })
      .catch(function () { if (box.isConnected) box.remove(); });
  }

  function fetchCart() {
    return origFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function refresh() {
    drawer.classList.add('is-loading');
    return fetchCart().then(function (cart) {
      render(cart);
      drawer.classList.remove('is-loading');
      return cart;
    }).catch(function () { drawer.classList.remove('is-loading'); });
  }

  function open(opts) {
    opts = opts || {};
    addedEl.classList.toggle('is-visible', !!opts.added);
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cd-lock');
    return refresh();
  }

  function close() {
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cd-lock');
  }

  function change(line, quantity) {
    drawer.classList.add('is-loading');
    return origFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); drawer.classList.remove('is-loading'); })
      .catch(function () { drawer.classList.remove('is-loading'); });
  }

  function addVariant(id) {
    drawer.classList.add('is-loading');
    return origFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(id), quantity: 1 })
    }).then(function () { addedEl.classList.add('is-visible'); return refresh(); })
      .catch(function () { drawer.classList.remove('is-loading'); });
  }

  /* Estilos del selector de talla en recomendados (se agregan al abrir la página) */
  function injectRecStyles() {
    if (document.getElementById('cd-recs-css')) return;
    var st = document.createElement('style');
    st.id = 'cd-recs-css';
    st.textContent = "  /* Recomendados: fila deslizable + selector rápido de talla */\n  .cd__recs-list { display: flex; gap: 0.7rem; overflow-x: auto; scroll-snap-type: x mandatory; padding-bottom: 0.4rem; scrollbar-width: thin; scrollbar-color: rgba(255,255,255,0.2) transparent; }\n  .cd__recs-list .cd__rec { flex: 0 0 calc(50% - 0.35rem); scroll-snap-align: start; display: flex; flex-direction: column; }\n  .cd__rec p { flex: 1; }\n  .cd__sizes { display: flex; flex-wrap: wrap; gap: 0.3rem; }\n  .cd__sizes[hidden] { display: none; }\n  .cd__rec .cd__size {\n    flex: 1 0 calc(33.333% - 0.3rem); min-width: 0; width: auto;\n    background: transparent; color: #fff; border: 1px solid rgba(255,255,255,0.35); border-radius: 999px;\n    padding: 0.42rem 0; font-size: 0.68rem; font-weight: 700; letter-spacing: 0.04em;\n  }\n  .cd__rec .cd__size:hover { background: #fff; color: #111; }\n  .cd__rec .cd__size:disabled { opacity: 0.3; text-decoration: line-through; cursor: not-allowed; background: transparent; color: #fff; }\n  .cd__rec-link { display: block; text-align: center; margin-top: 0.45rem; font-size: 0.66rem; color: rgba(255,255,255,0.6); text-decoration: underline; }\n  .cd__rec-link:hover { color: #fff; }\n";
    document.head.appendChild(st);
  }

  function init() {
    drawer = document.querySelector('[data-cd]');
    overlay = document.querySelector('[data-cd-overlay]');
    if (!drawer || !overlay) return;
    body = drawer.querySelector('[data-cd-body]');
    ship = drawer.querySelector('[data-cd-ship]');
    subtotalEl = drawer.querySelector('[data-cd-subtotal]');
    countEl = drawer.querySelector('[data-cd-count]');
    addedEl = drawer.querySelector('[data-cd-added]');
    foot = drawer.querySelector('[data-cd-foot]');

    rememberGender();
    injectRecStyles();

    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cd-close]')) { close(); return; }
      var q = e.target.closest('[data-cd-qty]');
      if (q) { change(Number(q.dataset.cdQty), Math.max(0, Number(q.dataset.q))); return; }
      var sizes = e.target.closest('[data-cd-sizes]');
      if (sizes) {
        var panel = sizes.parentNode.querySelector('.cd__sizes');
        sizes.hidden = true;
        if (panel) panel.hidden = false;
        return;
      }
      var add = e.target.closest('[data-cd-add]');
      if (add) { addVariant(add.dataset.cdAdd); return; }
      var go = e.target.closest('[data-cd-go]');
      if (go) { window.location.href = go.dataset.cdGo; }
    });

    // El ícono del carrito abre el panel en vez de ir a /cart.
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href="/cart"], a[href$="/cart"]');
      if (!link || drawer.contains(link)) return;
      if (document.body.classList.contains('template-cart')) return;
      e.preventDefault();
      open();
    });

    window.HVMANCartDrawer = { open: open, close: close, refresh: refresh };
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
